import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { TreeItem } from '../../models/tree-item';
import { ConnectProviderService } from 'app/connect/core/connect-provider.service';
import { PropertiesReplication } from '../../models/properties-replication';

@Component({
  selector: 'connect-replication-detail-properties',
  templateUrl: 'connect-replication-detail-properties.component.html',
  styleUrls: ['connect-replication-detail-properties.component.scss']
})
export class ConnectReplicationDetailPropertiesComponent implements OnInit, OnChanges {
  public replicatedEntities: Array<TreeItem> = [];
  public infoReplicatedProperties: PropertiesReplication;
  public isLoading: boolean = false;
  @Input() currentItemSelected: TreeItem;

  constructor(private _connectProviderService: ConnectProviderService) {
  }

  ngOnInit() {
    this.infoReplicatedProperties = new PropertiesReplication();
  }

  ngOnChanges() {
    if (this.currentItemSelected) {
      this.isLoading = true;
      this._connectProviderService.getReplicatedEntities(this.currentItemSelected.id).subscribe((data) => {
        this.replicatedEntities = data;
      });
      this._connectProviderService.getInfoById(this.currentItemSelected.id).subscribe((data: any) => {
        this.infoReplicatedProperties.name = data.name;
        this.infoReplicatedProperties.displayName = data.content.displayName;
        this.infoReplicatedProperties.description = data.content.description;
        this.infoReplicatedProperties.startDate = data.content.schedules[0].startDate;
      });
      this._connectProviderService.getNextRunTime(this.currentItemSelected.id).subscribe((data) => {
        this.isLoading = false;
        this.infoReplicatedProperties.nextRunTime = data.NextRunTime;
      });
    }
  }

  scheduleNow() {
    this._connectProviderService.postScheduleNow(this.currentItemSelected.id).subscribe((data) => {
      this.infoReplicatedProperties.nextRunTime = data.NextRunTime;
    });
  }
}
